export function isEven(value) {
  if (value % 2 === 0) return true;
  return false;
}
